import * as styles from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={styles.wrap}>
      <div className={styles.spinner} role="status">
        <span className="sr-only">Loading...</span>
      </div>
      <p className={styles.text}>Loading...</p>
    </div>
  );
};

export default Loader;
